import type { Action } from 'redux'
import { defaultGetParams as getParams } from '../../signalr/helpers'
import type { StreamDefinition } from '../../signalr/types'
import { activityLogAddActivity } from './actions'
import type { Activity } from './types'

export const fetchActivityLogDefinition: StreamDefinition<
  [],
  Activity[],
  Action
> = {
  method: 'GetActivity',
  strategy: 'switch',
  getParams,
  mapResponse: activityLogAddActivity,
  errorAction: 'activityLog.fetchFail',
  cancelOn: ['activityLog.fetchCancel']
}
